<template>
  <div class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
    <div>
      <article>
        <h1>
          <span class="animated-text">🛠️</span>
          {{ $t('reusable.errorPages.maintenanceViewTitle') }}
        </h1>
        <div>
          <p>
            {{ $t('reusable.errorPages.maintenanceViewMessage') }}
            <a href="mailto:admin@klearning.cl">{{ $t('reusable.errorPages.maintenanceViewEmailLink') }}</a>.
          </p>
          <p>{{ $t('reusable.errorPages.maintenanceViewTeam') }}</p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintenanceView",
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
body {
  text-align: center;
  padding: 150px;
}
h1 {
  font-size: 50px;
}
h1 >>> .animated-text {
  font-size: 72px;
  color: #ff5722;
  animation: fadeIn 2s ease infinite;
  margin: 0;
}
body {
  font: 20px Helvetica, sans-serif;
  color: #333;
}
article {
  display: block;
  text-align: left;
  width: 800px;
  margin: 0 auto;
}
a {
  color: #f16558;
  text-decoration: none;
}
a:hover {
  color: #333;
  text-decoration: none;
}
</style>